module.exports = __webpack_public_path__ + "static/media/library.9eec37f0.png";